import { apiRequest } from '@/domains/api';

/**
 * Who has a record open (WEB-11 AC2) — survey-api's `/api/v1/admin/website/presence/{kind}/{id}`
 * (its `docs/superpowers/specs/2026-10-07-website-content-design.md` §5), and the sole reader.
 *
 * Presence, not a lock: a mark refuses nothing and lapses 60 seconds after the last one, so an
 * editor marks on a heartbeat (`presence.tsx`) and a crashed tab needs no release.
 */
export type ContentEditKind = 'post' | 'member' | 'event';

/** Somebody else with the record open, and since when (ISO). */
export interface IContentPresence {
  accountId: string;
  email: string;
  openedAt: string;
}

function presencePath(kind: ContentEditKind, recordId: string): string {
  return `/api/v1/admin/website/presence/${kind}/${encodeURIComponent(recordId)}`;
}

export const presenceApi = {
  /** Marks the record open for the caller; answers everyone else with it open. */
  mark(kind: ContentEditKind, recordId: string, signal?: AbortSignal): Promise<IContentPresence[]> {
    return apiRequest<IContentPresence[]>(presencePath(kind, recordId), { method: 'PUT', signal });
  },

  leave(kind: ContentEditKind, recordId: string): Promise<null> {
    return apiRequest<null>(presencePath(kind, recordId), { method: 'DELETE' });
  }
};
